import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';


export interface DataSetModel {
	data: []
}

export interface BarChartModel {
	graph?: {
		labels: any[],
		datasets: DataSetModel[],
		graphID?: string,
		graphTitle?: string
	},
	avgGap?: number,
	all?: any[]
}

@Component({
	selector: 'app-horizontal-bar-chart',
	templateUrl: './horizontal-bar-chart.component.html',
	styleUrls: ['./horizontal-bar-chart.component.scss']
})
export class HorizontalBarChartComponent implements OnInit {

	@Input() barData: BarChartModel;
	@Input() barColor = '0 145 234';

	@Output() detail = new EventEmitter();
	constructor() { }

	ngOnInit(): void {
	}

	ngOnChanges(changes) {
		if (changes.barData && changes.barData.currentValue) {
		}
	}

	info(data) {
		this.detail.emit(data);
	}

}
